import React from "react";
import "./FeaturesItem.scss";
import Image from "../../Elements/Image/Image.tsx";
import RightComponent from "./RightComponent.js";
import parse from "html-react-parser";
import { useParams } from "react-router";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const FeaturesPageComponent = ({ myprops, isSkeleton }) => {
  const { featuresPage } = useParams();
  const { getTextByKey, getLanguageCulture } = useContent();
  const imageName = myprops[featuresPage]?.service_image.split(".png")[0];
  const listSkeletonText = [900, 600, 800, 700, 500, 940, 600, 800, 700, 500];
  const skeletonTitle = () => {
    return <Skeleton width={400} height={40} />;
  };

  const skeletonText = (num) => {
    return <Skeleton width={num} height={18} />;
  };

  return (
    <div className="features-item-page-wrapper">
      <div className="features-header-router">
        <a
          className="breadcrumb-trail"
          href={`/${getLanguageCulture().substring(0, 2)}/features`}
          data-uw-styling-context="true"
        >
          {getTextByKey("features")} {" » "}
          &nbsp;
        </a>
        {myprops[featuresPage]
          ? myprops[featuresPage].service_category_title
          : null}
      </div>
      <div className="features-item-container">
        <div className="left-section">
          <div className="upper-left-section">
            <div className="header-feature-page">
              <div className="feature-image">
                {imageName && (
                  <Image
                    className="feature-icon features-category-icon"
                    xxxl="true"
                    name={`features/${imageName}`}
                    ext="png"
                  />
                )}
                <h1 className="category-title">
                  {!isSkeleton
                    ? myprops[featuresPage]
                      ? myprops[featuresPage].service_category_title
                      : skeletonTitle()
                    : skeletonTitle()}
                </h1>
              </div>
            </div>
            <div className="answer">
              <div className="answer-text">
                {!isSkeleton
                  ? myprops[featuresPage]?.service_text &&
                    parse(myprops[featuresPage]?.service_text)
                  : listSkeletonText.map((num) => skeletonText(num))}
              </div>
            </div>
          </div>
          <div className="bottom-left-section"> </div>
        </div>
        <RightComponent myprops={myprops} />
      </div>
    </div>
  );
};

export default FeaturesPageComponent;
